<template>

    <div class="mt-[76px]">
        <div class="grid grid-cols-1 md:grid-cols-10 gap-4 items-center">
            <div class="col-span-1 md:col-span-6 order-2 md:order-1">
                <div v-html="ourStoryTitle"
                    class="text-[36px] font-[400] font-outfit leading-[normal]"/>
                <div v-html="ourStorySubTitle" class="text-[24px] my-[24px] font-[400] font-outfit leading-[normal] text-left"/>

                <div class="flex justify-stretch md:justify-start">

                    <button
                        @click="navigateTo"
                       class="outline outline-primary-500 outline-1 text-primary-500 text-[16px] font-[600] rounded-xl w-full md:w-auto  py-2 px-[20px] hover:shadow hover:bg-primary-500 hover:text-white duration-100"
                    >
                        Read About Our Story
                    </button>

                </div>

            </div>
            <div class="col-span-1 md:col-span-4 order-1 md:order-2">
                <img
                    :src="ourStoryImageSrc"
                    alt=""
                    class="hover:opacity-90 transition-opacity"
                />
            </div>

        </div>
    </div>

</template>
<script>


export default {
    components: {},
    props: {
        ourStoryTitle: {
            type: String,
            default: "A future where every child learns about climate change and becomes a steward of our planet"
        },
        ourStorySubTitle: {
            type: String,
            default: "We are on a mission to make climate change teaching and learning accessible to all. By enabling educators from all subjects and grade levels to teach about climate change, we believe that the next generation will be inspired to take climate action."
        },
        ourStoryImageSrc: {
            type: String,
            default: "/img/about-us/Blaze-holding-globe-1.png"
        },
        ourStoryButtonLink:{
            type: String,
            default: null
        },
        ourStoryOpenNewTab:{
            type: Boolean,
            default: false
        }
    },
    methods: {
        navigateTo() {
            window.open(this.ourStoryButtonLink, this.ourStoryOpenNewTab ? "_blank" : "_self");
        }
    },
};
</script>

<style scoped>

</style>
